import CustomDatePicker from 'components/common/CustomDatePicker';
import ClickableLink from './ClickableLink';

export const getWidgets = () => {
  return {
    date: CustomDatePicker,
    URLWidget: ClickableLink,
  };
};
